import domready from 'domready'
import createApp from '@/javascript/components/blog-posts/app'

domready(() => {
  for (let element of document.querySelectorAll('[data-vue="blog-posts"]')) {
    element.vm = createApp(element)
  }
})
